// 初期表示
export const PAGE_INIT = "corp/report/PAGE_INIT";
export const LOAD_REPORT = "corp/report/LOAD_REPORT";
export const OPTION_CHANGE = "corp/report/OPTION_CHANGE";
// 選択項目のセット
export const SET_ITEMS = "corp/report/SET_ITEMS";
export const SET_SORT_OPTIONS = "corp/report/SET_SORT_OPTIONS";
